module.exports = __webpack_public_path__ + "static/media/accounts_employees_manage.0180751d.svg";